module.exports = __webpack_public_path__ + "img/qijian-guanggao.ae3d2cc5.svg";